import type { Row } from '@tanstack/react-table';
import type { RowProps } from 'shared/components/nv-table';
import { ActionItemRowHandlers, ADD_LINK_ID, NEW_ACTION_ITEM_ID, PreAssignedActionItem, SavedActionItem } from '../types';
import AddActionItemLink from './add-action-item-link';
import ActionItemEditRow from './action-item-edit-row';
import ActionItemReadRow from './action-item-read-row';

type ActionItemRowProps = RowProps<PreAssignedActionItem> & ActionItemRowHandlers;

const ActionItemRow = ({
  row,
  className,
  getCellStyle,
  editingId,
  setEditingId,
  setShowAddRow,
  onSave,
  onDelete,
  onHasUnsavedChanges,
}: ActionItemRowProps) => {
  const { id } = row.original;

  if (id === ADD_LINK_ID) {
    return (
      <AddActionItemLink
        className={className}
        setShowAddRow={setShowAddRow}
      />
    );
  }

  const isNewRow = id === NEW_ACTION_ITEM_ID;
  const isEditing = isNewRow || id === editingId;

  if (isEditing) {
    return (
      <ActionItemEditRow
        row={row.original}
        className={className}
        getCellStyle={getCellStyle}
        isNewRow={isNewRow}
        setEditingId={setEditingId}
        setShowAddRow={setShowAddRow}
        onSave={onSave}
        onHasUnsavedChanges={onHasUnsavedChanges}
      />
    );
  }

  return (
    <ActionItemReadRow
      row={row as unknown as Row<SavedActionItem>}
      className={className}
      getCellStyle={getCellStyle}
      setEditingId={setEditingId}
      onSave={onSave}
      onDelete={onDelete}
    />
  );
};

export default ActionItemRow;
